<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <div v-else>
      <div
        class="profilebg"
        :style="{
          'background-image':
            'url(' +
            (data.profile_cover
              ? data.profile_cover
              : require('../assets/bluebg.jpg')) +
            ')',
        }"
      >
        <!-- xx -->
        <div style="position: absolute; right: 10px; top: 10px">
          <v-btn
            dark
            :loading="imgCoverLoading"
            @click="$refs.uploadCover.onClickUploadFile()"
            icon
            small
          >
            <v-icon small style="color: white">mdi-square-edit-outline</v-icon>
          </v-btn>
        </div>
        <div>
          <div class="text-center pt-7 Kanit">
            <div
              style="
                position: relative;
                height: 125px;
                width: 125px;
                margin-left: auto;
                margin-right: auto;
              "
            >
              <img class="profileimg" :src="data.profile_pic" />

              <div
                v-if="imgLoading"
                style="
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                "
              >
                <v-progress-circular
                  indeterminate
                  color="white"
                ></v-progress-circular>
              </div>
              <v-btn
                @click="$refs.uploadImg.onClickUploadFile()"
                class="editbutton"
                fab
                x-small
                color="primary"
              >
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </div>
            <div class="mt-3">
              <p style="margin-bottom: 3px; font-size: 24px; color: white">
                {{ data.name }}
              </p>
              <div>
                <div v-if="data.role.includes('ช่าง')">
                  <v-chip small>
                    <v-icon style="color: rgb(9 76 197)"
                      >mdi-format-paint</v-icon
                    >ช่างทาสี
                  </v-chip>
                </div>
                <div v-if="data.role.includes('ร้านค้า')">
                  <v-chip small>
                    <v-icon style="color: #d08600">mdi-store</v-icon>ร้านค้า
                  </v-chip>
                </div>
                <div v-if="data.role.includes('สถาปนิก')">
                  <v-chip small>
                    <v-icon style="color: rgb(0 156 84)">mdi-set-square</v-icon
                    >สถาปนิก
                  </v-chip>
                </div>
                <div v-if="data.role.includes('เจ้าของบ้าน')">
                  <v-chip small>
                    <v-icon style="color: rgb(197 9 9)">home</v-icon>เจ้าของบ้าน
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
          <div v-show="false">
            <uploadfile
              @startImgloading="startImgloading"
              ref="uploadImg"
              @input="onChangeImage"
              v-model="data.profile_pic"
            ></uploadfile>
            <uploadfile
              @startImgloading="startImgCoverloading"
              ref="uploadCover"
              @input="onChangeCoverImage"
              v-model="data.profile_cover"
            ></uploadfile>
          </div>
        </div>
        <div class="radiusfake"></div>
      </div>
      <div class="contentpad Kanit">
        <v-container style="position: relative; top: -17px" class="px-9 pt-0">
          <v-list two-line>
            <template>
              <v-list-item @click="active = !active">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #f5c644"
                          >mdi-format-list-checkbox</v-icon
                        >
                      </span>
                      <span class="menufont">คำสั่งซื้อของฉัน</span>
                    </div>
                    <div>
                      <v-icon v-if="active">mdi-chevron-down</v-icon>
                      <v-icon v-else>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>
              <div v-if="active">
                <div
                  style="
                    display: flex;
                    justify-content: space-evenly;
                    margin-top: 30px;
                    margin-bottom: 25px;
                  "
                >
                  <div
                    @click="showOrdersDialog('รอการชำระเงิน')"
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.wait_to_pay
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          style="font-size: 44px"
                          >mdi-wallet-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.wait_to_pay"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.wait_to_pay }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center"
                      :style="`color: ${
                        data.orderstatus.wait_to_pay ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      ที่ต้องชำระ
                    </div>
                  </div>
                  <div
                    @click="showOrdersDialog('รอการจัดส่ง')"
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.wait_to_ship
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          style="font-size: 44px"
                          >mdi-truck-delivery-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.wait_to_ship"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.wait_to_ship }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center"
                      :style="`color: ${
                        data.orderstatus.wait_to_ship ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      ที่ต้องจัดส่ง
                    </div>
                  </div>
                  <div
                    @click="showOrdersDialog('จัดส่งสินค้า')"
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.shipped ? '#0a4ea2' : 'darkgrey'
                          }`"
                          style="font-size: 44px"
                          >mdi-package-variant-closed</v-icon
                        >
                        <div v-if="data.orderstatus.shipped" class="numbericon">
                          <div>{{ data.orderstatus.shipped }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center"
                      :style="`color: ${
                        data.orderstatus.shipped ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      ที่ต้องได้รับ
                    </div>
                  </div>
                </div>
              </div>

              <v-list-item @click="changeView('CustomerAddress')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: green"
                          >mdi-home-map-marker</v-icon
                        >
                      </span>
                      <span class="menufont"
                        >ที่อยู่ของฉัน / ที่อยู่จัดส่ง</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: rgb(179 179 179)"
                          >mdi-bell-outline</v-icon
                        >
                      </span>
                      <span class="menufont" style="color: rgb(179 179 179)"
                        >แจ้งเตือน</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="changeView('Cart')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #ff9b45"
                          >mdi-cart-outline</v-icon
                        >
                      </span>
                      <span class="menufont">ตะกร้าสินค้า</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: rgb(179 179 179)"
                          >mdi-history</v-icon
                        >
                      </span>
                      <span class="menufont" style="color: rgb(179 179 179)"
                        >ประวัติการใช้งาน</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="changeView('ForgetPassword')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #05a3ff"
                          >mdi-shield-key-outline</v-icon
                        >
                      </span>
                      <span class="menufont">รหัสผ่าน / เปลี่ยนรหัสผ่าน</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="logout">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: black"
                          >mdi-logout</v-icon
                        >
                      </span>
                      <span class="menufont">ออกจากระบบ</span>
                    </div>
                    <div style="color: darkgrey">
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-list>
        </v-container>
      </div>
      <div>
        <v-dialog v-model="showorders" persistent fullscreen>
          <v-card>
            <v-card-text v-if="showorders">
              <div class="text-right pa-4">
                <v-btn @click="showorders = false" icon small>
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <OrderList
                :title="activeorder"
                :user="data"
                :orders="orderlist"
              ></OrderList>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
import OrderList from "./OrderList.vue";
import uploadfile from "@/components/UploadSingleFile.vue";
export default {
  data() {
    return {
      imgCoverLoading: false,
      loading: true,
      showorders: false,
      active: true,
      activeorder: "",
      data: "",
      imgLoading: false,
    };
  },
  components: {
    Loading,
    OrderList,
    uploadfile,
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    query() {
      return this.$store.state.query;
    },
    orderlist() {
      if (this.activeorder) {
        return this.data.orderlist.filter(
          (el) => el.status == this.activeorder
        );
      } else return [];
    },
  },
  async mounted() {
    await this.checkLoginStatus();
    await this.getCustomerInfo();
    this.loading = false;
  },
  methods: {
    startImgloading() {
      this.imgLoading = !this.imgLoading;
    },
    startImgCoverloading() {
      this.imgCoverLoading = !this.imgCoverLoading;
    },
    onChangeImage() {
      var vm = this;
      this.imgLoading = true;
      var data = {
        userid: vm.$store.state.userid,
        apptype: vm.query.apptype,
        pageid: this.query.pageid,
        profile_pic: this.data.profile_pic,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toarcustomeruploadprofile",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          this.imgLoading = false;
        });
    },
    onChangeCoverImage() {
      var vm = this;
      this.imgCoverLoading = true;
      var data = {
        userid: vm.$store.state.userid,
        apptype: vm.query.apptype,
        pageid: this.query.pageid,
        profile_cover: this.data.profile_cover,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toauploadprofilecover",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          this.imgCoverLoading = false;
        });
    },
    showOrdersDialog(type) {
      this.activeorder = type;
      this.showorders = true;
    },
    changeView(view) {
      this.$store.state.redirect = "CustomerProfile";
      this.query.view = view;
    },
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: vm.$store.state.userid,
                apptype: vm.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              this.$store.state.redirect = "CustomerProfile";
              this.query.view = "Agreement";
              resolve();
            } else {
              resolve();
            }
          });
      });
    },
    logout() {
      var vm = this;
      vm.$swal.fire({
        icon: "question",
        text: "ต้องการออกจากระบบใช่หรือไม่?",
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return new Promise((resolve, reject) => {
            var data = {
              userid: vm.$store.state.userid,
              apptype: vm.query.apptype,
              pageid: vm.query.pageid,
            };
            axios
              .put(
                "https://communitybotbyzwizai.herokuapp.com/toalogoutusers",
                data,
                {
                  headers: { AUTHORIZATION: "Bearer xxx xxx" },
                }
              )
              .then(async (response) => {
                if (response.data && response.data.responsecode == 400) {
                  await this.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                  });
                  return;
                }
                if (response.data.responsecode == 200) {
                  vm.$store.state.redirect = "CustomerProfile";
                  vm.query.view = "Login";
                  resolve();
                }
              });
          });
        },
      });
    },
    getCustomerInfo() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toarcustomerpersonalinfo",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: vm.$store.state.userid,
                apptype: vm.query.apptype,
                pageid: vm.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              vm.data = response.data.data[0];
              resolve();
            } else {
              vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            }
          });
      });
    },
  },
};
</script>

<style lang="scss">
.radiusfake {
  background-color: white;
  height: 30px;
  width: 100%;
  border-radius: 20px 20px 0px 0px;
  position: absolute;
  bottom: -2px;
  left: 0px;
}
.profilebg {
  // background-image: url("../assets/bluebg.jpg");
  background-size: cover;
  padding-bottom: 50px;
  position: relative;
}
.profileimg {
  height: 100%;
  width: 100%;
  border-radius: 99px;

  border: 5px white solid;
}
.editbutton {
  position: absolute;
  right: 0px;
  bottom: 0px;
}
.contentpad {
  width: 100%;
  background-color: white;
}
.menufont {
  color: #0a4ea2;
  font-size: 16px;
}
.iconmenu {
  font-size: 29px !important;
}
.flexcontainer {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.ordericon {
  position: relative;
}
.numbericon {
  width: 21px;
  height: 21px;
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: center;
  border-radius: 99px;
  color: white;
  background-color: #d10a0a;
  top: -11px;
  left: -7px;
}
</style>